import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import "../../styles/ApproveRejectPopup.css";
import axiosInstance from '../../axiosInstance';
import AsyncSelect from "react-select/async";
import { toast } from "react-toastify";
import SapCsvSafeInput from "../../CommonRemarksRestriction/SapCsvSafeInput";

const CostApproveRejectPopup = ({
    isOpen,
    onClose,
    onSubmit,
    actionType,
    invoice,
    isLoading
}) => {
    const [comment, setComment] = useState("");
    const [error, setError] = useState("");

    const header = invoice?.approvalData?.invoice_header;
    const lines = invoice?.approvalData?.invoice_lines || [];
    const invoiceMode = header?.invoice_mode;
    const plantCodeFromLine = lines[0]?.plant_code || "";

    const [formData, setFormData] = useState({
        remarks: "",
        tax_code: null,
        plant_id: null,
        plant_code: ""
    });

    useEffect(() => {
        if (isOpen && header) {
            setComment("");
            setError("");

            setFormData({
                remarks: header.cost_header_remarks || "",
                tax_code: header.tax_code
                    ? {
                        label: header.tax_code,
                        value: header.tax_code_id
                    }
                    : null,
                plant_id: lines[0]?.plant_id || null,
                plant_code: plantCodeFromLine
            });
        }
    }, [isOpen, header]);

    if (!isOpen || !invoice) return null;

    const loadPlantCodeOptions = async (inputValue) => {
        try {

            const res = await axiosInstance.get("/plant_code/autosuggestion", {
                params: {
                    term: inputValue || "",
                    division_type: header?.division_type
                }
            });

            return res.data.autosuggestion.map(item => ({
                label: item.label,
                value: item.value
            }));

        } catch (error) {
            console.error("Plant code autosuggest error", error);
            return [];
        }
    };

    const handleSubmit = () => {
        if (!comment.trim()) {
            setError("Comment is required.");
            toast.error(`${actionType === "approved" ? "Approve" : "Reject"} comments are mandatory`);
            return;
        }

        if (invoiceMode === "NON_PO" && !formData.tax_code) {
            toast.error("Tax Code is mandatory");
            return;
        }

        const payload = {
            comments: comment,
            cost_header_remarks: formData.remarks,
            ...(formData.plant_code && {
                plant_id: formData.plant_id,
                plant_code: formData.plant_code
            })
        };

        if (invoiceMode === "NON_PO") {
            payload.tax_code = formData.tax_code?.value || null;
        }

        onSubmit(payload);

        console.log("Popup payload:", payload);
    };

    const loadTaxCodes = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/projects/get_tax_code", {
                params: { term: inputValue || "" }
            });

            const data = res.data?.autosuggestion || [];

            return data.map(item => ({
                label: item.label,
                value: item.value
            }));

        } catch (error) {
            console.error("Tax code error:", error);
            return [];
        }
    };


    return (
        <div className="approve-reject-modal" onClick={onClose}>
            <div
                className="approve-reject-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="approve-reject-submit-header">
                    <h3>
                        {actionType === "approved" ? "Approve" : "Reject"} Invoice
                    </h3>

                    <div
                        className="approve-reject-close-btn"
                        onClick={onClose}
                    >
                        <X size={16} />
                    </div>
                </div>

                {/* Body */}
                <div className="approve-reject-scroll-body">

                    {/* Comments */}
                    <div className="approve-reject-form-group">
                        <label className="approve-reject-label">
                            {actionType === "approved" ? "Approve" : "Reject"} Comments <span style={{ color: 'red' }}>*</span>
                        </label>
                        <textarea
                            value={comment}
                            onChange={(e) => {
                                let value = e.target.value;
                                value = value.replace(/,/g, "");
                                value = value.replace(/^\s+/, "");
                                setComment(value);
                                if (value.trim()) setError("");
                            }}
                            placeholder="Enter your comments"
                        />
                    </div>

                    {error && <div className="error-msg">{error}</div>}

                    {/* FORM */}
                    <div className="approve-reject-popup-container">
                        <div className="approve-reject-popup-cost-grid"
                            style={{
                                // gridTemplateColumns:
                                //     invoiceMode === "NON_PO"
                                //         ? "1fr 1fr 0.4fr"
                                //         : "1fr 1fr"

                                gridTemplateColumns: "1fr 1fr"
                            }}>
                            {/* Remarks */}
                            <div className="approve-reject-popup-form-group">
                                <label className="approve-reject-popup-label">
                                    Remarks to Vendor
                                </label>
                                <SapCsvSafeInput
                                    className="approve-reject-popup-input"
                                    placeholder="Enter remarks"
                                    value={formData.remarks}
                                    maxLength={255}
                                    style={{ margin: "0px" }}
                                    onChange={(val) =>
                                        setFormData({
                                            ...formData,
                                            remarks: val
                                        })
                                    }
                                />
                                <div className="approve-reject-popup-helper">
                                    <span>{formData.remarks.length}/255</span>
                                </div>
                            </div>

                            {/* Tax Code */}
                            {invoiceMode === "NON_PO" && (
                                <div className="approve-reject-popup-form-group">
                                    <label className="approve-reject-popup-label">
                                        Tax Code <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <AsyncSelect
                                        value={formData.tax_code}
                                        onChange={(selected) =>
                                            setFormData({
                                                ...formData,
                                                tax_code: selected
                                            })
                                        }
                                        loadOptions={loadTaxCodes} menuShouldBlockScroll={true}
                                        placeholder="Search tax code..."
                                        cacheOptions
                                        defaultOptions
                                        isClearable
                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        styles={{
                                            control: (base, state) => ({ ...base, width: '100%', height: '37px', borderRadius: '8px', fontSize: '13px', fontFamily: 'Work Sans', borderColor: state.isFocused ? '#0747A6' : '#D0D6DF', boxShadow: state.isFocused ? '0 0 0 1px #0747A6' : 'none', }),
                                            container: (base) => ({ ...base, width: '100%' }),
                                            menu: (base) => ({ ...base, fontSize: '13px', fontFamily: 'Work Sans', }),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999, }),
                                        }}
                                        components={{ DropdownIndicator: null, IndicatorSeparator: null, }} />
                                </div>
                            )}

                            {/* <div className="approve-reject-popup-form-group">
                                <label className="approve-reject-popup-label">
                                    Plant Code
                                </label>
                                <AsyncSelect
                                    cacheOptions
                                    defaultOptions
                                    loadOptions={loadPlantCodeOptions}
                                    isClearable
                                    placeholder="Search Plant Code"
                                    value={
                                        formData.plant_id
                                            ? {
                                                label: formData.plant_code,
                                                value: formData.plant_id
                                            }
                                            : null
                                    }
                                    onChange={(selected) =>
                                        setFormData({
                                            ...formData,
                                            plant_id: selected?.value || null,
                                            plant_code: selected?.label || ""
                                        })
                                    }
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            minHeight: "40px",
                                            borderRadius: "12px",
                                            fontSize: "13px",
                                            width: "100%",
                                            borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
                                            boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
                                            "&:hover": { borderColor: "#454CF2" },
                                        }),
                                        container: (base) => ({ ...base, width: "100%" }),
                                        menu: (base) => ({ ...base, fontSize: "12px" }),
                                        menuList: (base) => ({
                                            ...base,
                                            maxHeight: "250px",
                                            overflowY: "auto"
                                        }),
                                    }}
                                />
                            </div> */}
                        </div>
                    </div>

                    {/* TABLE */}
                    <div
                        className="invoice_popup_outercategory"
                        style={{ backgroundColor: "#FFF7E8" }}
                    >
                        <div className="invoice_popup_category_subheader">
                            <div className="invoice_popup_element_list">

                                {/* Invoice Number */}
                                <div
                                    style={{
                                        backgroundColor: "#19324C",
                                        color: "#fff",
                                        padding: "12px 16px",
                                        fontSize: "15px",
                                        fontWeight: 600,
                                        borderRadius: "8px"
                                    }}
                                >
                                    INVOICE NO - {header?.inv_number || "-"}
                                </div>

                                {/* Table */}
                                <div className="table-container">
                                    <table className="invoice_table">
                                        <thead>
                                            <tr>
                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>S.NO</th>
                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>PROJECT CODE</th>
                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>VENDOR NAME</th>
                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>PLANT CODE</th>
                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>CHARGE CODE</th>
                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>DESCRIPTION</th>
                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>QTY</th>
                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>RATE</th>
                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center", padding: '10px' }}>NET TOTAL</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {lines.map((line, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{line.project_name}</td>
                                                    <td>{line.vendor_name}</td>
                                                    <td>{line.plant_code}</td>
                                                    <td>{line.charge_code || "-"}</td>
                                                    <td>{line.charge_name || "-"}</td>
                                                    <td>{line.unit_of_quantity}</td>
                                                    <td>{line.unit_of_rate}</td>
                                                    <td style={{ padding: '10px' }}>{line.net_total}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="approve-reject-modal-buttons">
                        <button onClick={onClose}>Cancel</button>
                        <button
                            onClick={handleSubmit}
                            disabled={isLoading}
                        >
                            {isLoading
                                ? actionType === "approved"
                                    ? "Approving..."
                                    : "Rejecting..."
                                : "Submit"}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default CostApproveRejectPopup;
